export function truncateString(v: string, maxLength: number): string {
    if (v.length > maxLength) {
        return v.slice(0, maxLength - 2) + '..'
    }
    return v
}